import { XState } from '@frontend/duck-tape';
import type { WizardEvent } from '../types';

// welcome -> email -> firstName -> lastName -> phoneNumber (optional) -> done
export const inviteMemberFlowMachine = XState.setup({
  guards: {
    validateField: (_, params: { field: string }) => !!params.field,
  },
  types: {
    events: {} as WizardEvent,
  },
}).createMachine({
  id: 'inviteMemberWizard',
  initial: 'welcome',
  states: {
    done: {
      type: 'final',
    },
    email: {
      on: {
        back: {
          target: 'welcome',
        },
        next: {
          guard: { params: { field: 'email' }, type: 'validateField' },
          target: 'firstName',
        },
      },
    },
    firstName: {
      on: {
        back: {
          target: 'email',
        },
        next: {
          guard: { params: { field: 'firstName' }, type: 'validateField' },
          target: 'lastName',
        },
      },
    },
    lastName: {
      on: {
        back: {
          target: 'firstName',
        },
        next: {
          guard: { params: { field: 'lastName' }, type: 'validateField' },
          target: 'phoneNumber',
        },
      },
    },
    phoneNumber: {
      on: {
        back: {
          target: 'lastName',
        },
        next: {
          target: 'done',
        },
      },
    },
    welcome: {
      on: {
        next: {
          target: 'email',
        },
      },
    },
  },
});
